import Flx from "./Flx";

const ScreenRoot = ({ children, id, sx, grow = 1, background = "#fafbfc" }) => {
  return (
    <Flx
      id={id}
      column
      sx={{ height: "100%", flexGrow: grow, background, ...sx }}
    >
      {children}
    </Flx>
  );
};

export default ScreenRoot;
